<script setup>
  import ComponentAlert from "@components/Alerts/Alert.vue";
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";

  defineOptions({
    name: "PatientinputComponentStepSuccessCarer",
  });

  defineProps({
    form: {
      type: Object,
      required: true,
    },
  });
</script>

<template>
  <PatientinputComponentStep title="Vielen Dank!" :back-button="false" :forward-button="false" :test-id="getTestId()">
    <ComponentAlert type="succes" :test-id="getTestId('success-carer-step')">
      Ihre Angaben wurden erfolgreich übermittelt.
    </ComponentAlert>

    <div>
      <p>
        Bitte halten Sie folgende weitere Daten
        <span v-if="form.masterdata.patient.gender === 'female'">zur Patientin</span>
        <span v-else>zum Patienten</span>
        zum Medikationsgespräch bereit:
      </p>

      <ul class="list-disc pl-6">
        <li>
          Aktueller Medikationsplan

          <ul class="list-[circle] pl-6">
            <li>Dauermedikation</li>
            <li>Akutmedikation</li>
            <li>Bedarfsmedikation</li>
          </ul>
        </li>

        <li>Übersicht über Arzneimittel in Eigenverantwortung</li>
        <li>Ggf. Arztbrief/Krankenhausbericht</li>
        <li>Ggf. Pflegebericht</li>
      </ul>
    </div>
  </PatientinputComponentStep>
</template>
